import { createElement } from "rlink-react";

export default function IconRelicLogo(props) {
  return (
    <svg id="Layer_1" viewBox="0 0 232 196.72" {...props}>
      <g id="R25_Logo">
        <path
          fill="#FFE62B"
          d="M27.11,14.75c-0.61-1.46-0.86-4.49,2.69-9.2C33.34,0.82,39.68,1,39.68,1h47.69c7.18,0,10.97,5.52,14.32,11.36
		l5.99,9.99c53.41-16.91,117.21-10.08,119.94-9.76l3.38,0.37v58.25l-4.14-0.35c-0.69-0.07-69.73-5.91-114.62,15.7
		C63.53,111.1,69.58,190.82,69.65,191.63l0.34,4.09H2.21l-0.39-3.35c-0.45-3.9-10.01-94.45,49.64-136.75
		C51.46,55.62,27.72,16.2,27.11,14.75z"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/svg/iconRelicLogo.jsx